/* OB guide mobile list (rebuilt from the live build Oct 24 2026; counts the Worth the Drive filter in the filter badge). */
(function() {
 "use strict";
 if (window.__obMlist) return;
 window.__obMlist = !0;
 var MQ = window.matchMedia ? window.matchMedia("all") : {
  matches: !1,
  addListener: function() {}
 };

 function mobile() {
  return !!MQ.matches
 }

 function esc(s) {
  return String(s == null ? "" : s).replace(/[&<>"']/g, function(c) {
   return {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;"
   } [c]
  })
 }

 function truthy(v) {
  return v === !0 || /^(yes|true|1)$/i.test(String(v || "").trim())
 }

 function state() {
  try {
   return window.OB_GUIDE_V3 && window.OB_GUIDE_V3.state()
  } catch (_) {
   return null
  }
 }

 function get(k, d) {
  try {
   var v = window.localStorage.getItem(k);
   return v == null ? d : v
  } catch (_) {
   return d
  }
 }

 function put(k, v) {
  try {
   window.localStorage.setItem(k, v)
  } catch (_) {}
 }

 function track(name, val) {
  try {
   typeof window.gtag == "function" && window.gtag("event", "guide_filter", {
    filter_type: name,
    filter_value: val,
    filter_on: "on"
   })
  } catch (_) {}
 }
 var pref = {
   sort: get("obnSort", "rec") === "time" ? "time" : "rec",
   dens: get("obnDensity", "compact") === "comfy" ? "comfy" : "compact"
  },
  MAP = null,
  MAPN = -1;

 function itemFor(key) {
  var it = window.OB_GUIDE_ITEMS || [];
  if (!MAP || MAPN !== it.length) {
   MAP = {}, MAPN = it.length;
   for (var i = 0; i < it.length; i++) {
    var o = it[i];
    o && o.key != null && (MAP[String(o.key)] = o)
   }
  }
  return key && (MAP[key] || MAP[String(key).replace(/\|\d{4}-\d{2}-\d{2}$/, "")]) || null
 }

 function sv(d) {
  return '<svg class="obg-i" viewBox="0 0 24 24" aria-hidden="true">' + d + "</svg>"
 }
 var ICONS = [
   [/music|concert/i, '<path d="M9 18V5l11-2v13"/><circle cx="6.5" cy="18" r="2.5"/><circle cx="17.5" cy="16" r="2.5"/>'],
   [/comedy|karaoke/i, '<rect x="9" y="3" width="6" height="11" rx="3"/><path d="M5.5 11a6.5 6.5 0 0 0 13 0M12 17.5V21"/>'],
   [/market/i, '<path d="M3 20h18M5 20V10l7-6 7 6v10"/><path d="M10 20v-5h4v5"/>'],
   [/festival|fair/i, '<path d="M4 21V4M4 4l13 4-13 4"/><path d="M14 21h6"/>'],
   [/food|drink|happy/i, '<path d="M7 3v8M5 3v5a2 2 0 0 0 4 0V3M7 11v10M16 3c-2 1-3 4-3 7h3v11"/>'],
   [/outdoor|fitness|active/i, '<circle cx="14" cy="4.5" r="2"/><path d="M8 21l3-6 3 3v-6l-3-2-3 3M14 12l3 2 3-1"/>'],
   [/wildlife|nature/i, '<path d="M5 19c0-8 5-14 15-15-1 10-7 15-15 15zM5 19l7-7"/>'],
   [/space|stargaz|moon/i, '<path d="M20 14.5A8 8 0 1 1 9.5 4a6.5 6.5 0 0 0 10.5 10.5z"/>'],
   [/sport/i, '<circle cx="12" cy="12" r="9"/><path d="M3.5 9.5c4 1 8 4.5 9 11M20.5 14.5c-4-1-8-4.5-9-11"/>'],
   [/diy|workshop|art/i, '<path d="M12 3a9 9 0 1 0 0 18c1.5 0 2-1 2-2 0-1.5-1.5-1.5-1.5-3S14 14 16 14h2a3 3 0 0 0 3-3c0-4.5-4-8-9-8z"/><circle cx="7.5" cy="11" r="1"/><circle cx="10" cy="7" r="1"/><circle cx="15" cy="7.5" r="1"/>'],
   [/theat|perform/i, '<path d="M4 4h16v5a8 8 0 0 1-16 0z"/><path d="M8.5 8.5h.01M15.5 8.5h.01M9 12.5a4 4 0 0 0 6 0"/>'],
   [/film|movie/i, '<rect x="3" y="5" width="18" height="14" rx="2"/><path d="M7 5v14M17 5v14M3 9.5h4M3 14.5h4M17 9.5h4M17 14.5h4"/>'],
   [/trivia|game|bingo/i, '<circle cx="12" cy="12" r="9"/><path d="M9.5 9.5a2.5 2.5 0 1 1 3.5 2.3c-.6.3-1 .8-1 1.5v.7M12 17h.01"/>']
  ],
  CAL = '<rect x="3.5" y="5" width="17" height="15" rx="2"/><path d="M3.5 10h17M8 3v4M16 3v4"/>';

 function iconFor(label) {
  for (var i = 0; i < ICONS.length; i++)
   if (ICONS[i][0].test(label)) return sv(ICONS[i][1]);
  return sv(CAL)
 }
 var CSS = '#obg .obn-ml-bar,#obg .obn-ml-sortrow,#obg .obn-ml-tools,#obg .obn-ml-fab{display:none}@media all{#obg #obgList .obg-dlist{border-radius:16px}#obg #obgList .obg-r4w{position:relative}#obg #obgList a.obg-r4{display:grid!important;grid-template-columns:auto minmax(0,1fr) 52px;grid-template-areas:"time tags thumb" "title title thumb" "meta meta thumb";column-gap:8px;row-gap:2px;align-items:start;padding:9px 12px 10px 14px;min-height:72px;gap:1px 8px}#obg #obgList .obg-r4-time{grid-area:time;display:block;width:auto!important;min-width:0!important;margin:0;padding:0;font:700 12.5px/1.3 Inter,sans-serif!important;color:var(--or,#b4541f)!important;white-space:nowrap;text-align:left}#obg #obgList .obg-r4-tags{grid-area:tags;display:flex!important;align-items:center;gap:8px;min-width:0;margin:0!important;padding:0;overflow:hidden;white-space:nowrap;flex-wrap:nowrap}#obg #obgList .obg-r4-tags>*{flex:0 0 auto}#obg #obgList .obg-r4-pill{order:1;display:inline-flex;align-items:center;gap:5px;background:none!important;border:0!important;padding:0!important;height:auto!important;min-height:0;border-radius:0;font:600 11.5px/1.3 Inter,sans-serif!important;letter-spacing:0;box-shadow:none}#obg #obgList .obg-r4-pill:before{content:"";width:6px;height:6px;border-radius:50%;background:currentColor;flex:0 0 6px}#obg #obgList .obg-r4-pill+.obg-r4-pill{display:none}#obg #obgList .obg-r4-price{order:2;background:none!important;border:0!important;padding:0!important;font:600 11.5px/1.3 Inter,sans-serif!important;color:var(--muted,#5f6d74)}#obg #obgList .obg-r4-price.is-free{color:#2f7a4b}#obg #obgList .obn-more-cats{order:3;font:600 11px/1.3 Inter,sans-serif;color:var(--muted,#5f6d74)}#obg #obgList .obg-r4-title{grid-area:title;display:-webkit-box!important;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;white-space:normal!important;margin:1px 0 0;font:600 14.5px/1.28 Inter,sans-serif!important;color:var(--ink,#1b2a33)}#obg #obgList .obg-r4-title .obg-title{display:inline!important;white-space:normal!important;overflow:visible!important;text-overflow:clip!important;font:inherit!important}#obg #obgList .obg-r4-star{color:var(--or,#b4541f);font-size:13px;margin-right:1px}#obg #obgList .obg-r4-meta{grid-area:meta;display:block;margin:0;font:400 12.5px/1.35 Inter,sans-serif!important;color:var(--muted,#5f6d74);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}#obg #obgList .obg-r4-thumb{grid-area:thumb;position:relative;display:block!important;width:52px!important;height:52px!important;margin:0!important;border-radius:12px;overflow:hidden;align-self:start;background:var(--line2,#f0ebe2)}#obg #obgList .obg-r4-thumb img{width:100%;height:100%;object-fit:cover;display:block}#obg #obgList .obg-r4-thumb.obn-ico{display:flex!important;align-items:center;justify-content:center;padding:0!important}#obg #obgList .obg-r4-thumb.obn-ico .obg-i{width:24px;height:24px;color:currentColor;fill:none;stroke:currentColor;stroke-width:1.7;stroke-linecap:round;stroke-linejoin:round}#obg #obgList .obg-r4w>.obg-save{position:absolute!important;top:29px;right:-1px;left:auto;bottom:auto;width:44px!important;height:44px!important;margin:0!important;padding:0!important;display:flex;align-items:center;justify-content:center;background:none!important;border:0!important;box-shadow:none!important;z-index:2}#obg #obgList .obg-r4w>.obg-save:before{content:"";position:absolute;width:26px;height:26px;border-radius:50%;background:#fff;box-shadow:0 1px 4px rgba(27,42,51,.22)}#obg #obgList .obg-r4w>.obg-save .obg-i{position:relative;width:15px!important;height:15px!important}#obg.obn-comfy #obgList a.obg-r4{grid-template-columns:auto minmax(0,1fr) 72px;padding:14px 14px 14px 16px;min-height:100px;row-gap:4px}#obg.obn-comfy #obgList .obg-r4-thumb{width:72px!important;height:72px!important}#obg.obn-comfy #obgList .obg-r4-title{-webkit-line-clamp:3;font-size:16px!important}#obg.obn-comfy #obgList .obg-r4-meta{white-space:normal;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical}#obg.obn-comfy #obgList .obg-r4w>.obg-save{top:47px;right:1px}#obg #obgList .obg-dhead{position:sticky;top:calc(var(--obn-stick,0px) + var(--obn-bar,0px));z-index:4;display:flex;align-items:baseline;justify-content:space-between;gap:10px;margin:0 -16px 8px;padding:10px 16px 8px;background:var(--bg,#fbf8f2);border-bottom:1px solid var(--line,#e8e2d7);transition:top .2s}#obg #obgList .obg-dhead h3{display:flex;align-items:baseline;gap:8px;margin:0;font-size:21px;line-height:1.2;white-space:nowrap}#obg #obgList .obg-dhead h3 span{display:inline;margin:0;font:600 12.5px/1.2 Inter,sans-serif;color:var(--muted,#5f6d74)}#obg #obgList .obg-dcount{font:600 12px/1.2 Inter,sans-serif;color:var(--muted,#5f6d74);text-align:right}#obg #obgList .obg-dgroup{margin-bottom:14px}#obg .obg-datebar .obg-dcard,#obg .obg-dates .obg-dcard{min-height:44px;padding:5px 12px}#obg .obg-datebar .obg-dcard b,#obg .obg-dates .obg-dcard b{font-size:13.5px}#obg .obg-datebar .obg-dcard span,#obg .obg-dates .obg-dcard span{font-size:11.5px}#obg .obn-ml-bar{position:sticky;top:var(--obn-stick,0px);z-index:6;display:flex;align-items:center;gap:8px;margin:6px 0 4px;padding:8px 16px;background:var(--bg,#fbf8f2);transition:top .2s,box-shadow .2s}#obg .obn-ml-bar.is-stuck{box-shadow:0 6px 10px -8px rgba(27,42,51,.35)}#obg .obn-ml-bar label,#obg .obn-ml-bar button,#obg .obn-ml-sortrow label,#obg .obn-ml-sortrow button{position:relative;display:flex;align-items:center;gap:5px;min-width:0;min-height:44px;background:#fff;border:1px solid var(--line,#e8e2d7);border-radius:12px;font:600 13px/1.2 Inter,sans-serif;color:var(--ink,#1b2a33);padding:0 10px}#obg .obn-ml-bar .obn-ml-date,#obg .obn-ml-bar .obn-ml-area{flex:1 1 auto}#obg .obn-ml-bar{gap:6px}#obg .obn-ml-bar label{padding-right:24px}#obg .obn-ml-bar label:after,#obg .obn-ml-sortrow label:after{content:"";position:absolute;right:10px;top:50%;width:6px;height:6px;margin-top:-5px;border-right:1.8px solid currentColor;border-bottom:1.8px solid currentColor;transform:rotate(45deg);pointer-events:none;opacity:.6}#obg .obn-ml-bar label b,#obg .obn-ml-sortrow label b{font-weight:600;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}#obg .obn-ml-bar .obg-i,#obg .obn-ml-sortrow .obg-i{flex:0 0 15px;width:15px;height:15px;color:var(--muted,#5f6d74)}#obg .obn-ml-bar select,#obg .obn-ml-sortrow select{position:absolute;inset:0;width:100%;height:100%;opacity:0;font-size:16px;cursor:pointer}#obg .obn-ml-bar .obn-ml-filters{flex:0 0 auto}#obg .obn-ml-bar .obn-ml-filters i{font-style:normal;min-width:20px;height:20px;padding:0 6px;border-radius:999px;background:var(--navy,#16324a);color:#fff;font:700 11.5px/20px Inter,sans-serif;text-align:center}#obg .obn-ml-bar label.is-set,#obg .obn-ml-bar .obn-ml-filters.is-set{border-color:var(--navy,#16324a);box-shadow:inset 0 0 0 1px var(--navy,#16324a)}#obg .obn-ml-bar label.is-set .obg-i{color:var(--navy,#16324a)}#obg .obn-ml-sortrow{display:flex;justify-content:flex-end;align-items:center;gap:4px;margin:0 0 6px}#obg .obn-ml-sortrow label b{overflow:visible;text-overflow:clip}#obg .obn-ml-sortrow label{padding-right:28px;background:transparent;border-color:transparent;font-size:13px;color:var(--muted,#5f6d74)}#obg .obn-ml-sortrow label b{color:var(--ink,#1b2a33)}#obg .obn-ml-sortrow button{width:44px;justify-content:center;padding:0;background:transparent;border-color:transparent}#obg .obn-ml-sortrow button .obg-i{width:19px;height:19px;color:var(--ink,#1b2a33)}#obg .obn-ml-bar [hidden],#obg .obn-ml-sortrow[hidden]{display:none!important}@media (max-width:409px){#obg .obn-ml-bar label .obg-i{display:none}#obg .obn-ml-bar label{padding-left:12px}}}';

 function timeMin(txt) {
  var t = String(txt || "").trim().toLowerCase();
  if (!t || /all day|thru|through|ongoing/.test(t)) return -1;
  if (/tba|tbd/.test(t)) return 2e3;
  var m = t.match(/(\d{1,2})(?::(\d{2}))?\s*(am|pm|a|p)?/);
  if (!m) return 1500;
  var h = +m[1] % 12,
   mi = +(m[2] || 0),
   pm = /p/.test(m[3] || "");
  return (pm ? h + 12 : h) * 60 + mi
 }

 function enhance(w) {
  if (!w.getAttribute("data-obn")) {
   w.setAttribute("data-obn", "1");
   var a = w.querySelector("a.obg-r4"),
    sb = w.querySelector("[data-save]");
   if (a) {
    var key = sb ? sb.getAttribute("data-save") : "",
     it = itemFor(key),
     r = it && it.__obRaw ? it.__obRaw : it,
     pills = a.querySelectorAll(".obg-r4-pill"),
     label = pills.length ? pills[0].textContent.trim() : "",
     tags = a.querySelector(".obg-r4-tags");
    if (pills.length > 1 && tags && !tags.querySelector(".obn-more-cats")) {
     var mc = document.createElement("span");
     mc.className = "obn-more-cats", mc.textContent = "+" + (pills.length - 1), mc.title = Array.prototype.slice.call(pills, 1).map(function(p) {
      return p.textContent.trim()
     }).join(", "), tags.appendChild(mc)
    }
    tags || (tags = document.createElement("span"), tags.className = "obg-r4-tags", a.appendChild(tags));
    var own = r && r.image && /^https?:/.test(String(r.image)),
     th = a.querySelector(".obg-r4-thumb");
    if (!own) {
     th || (th = document.createElement("span"), th.className = "obg-r4-thumb", a.appendChild(th));
     var pc = pills.length ? (pills[0].className.match(/obg-p-[a-z]+/) || [""])[0] : "";
     if (th.className = "obg-r4-thumb obn-ico" + (pc ? " " + pc : ""), th.setAttribute("aria-hidden", "true"), th.innerHTML = iconFor(label || r && r.cat || ""), pills.length) try {
      var pcs = getComputedStyle(pills[0]);
      th.style.color = pcs.color, th.style.background = "color-mix(in srgb, " + pcs.color + " 13%, #fff)"
     } catch (_) {}
    }
    var im = th && th.querySelector("img");
    if (im) {
     var toTile = function() {
      if (!(!th.parentNode || th.classList.contains("obn-ico"))) {
       var pc2 = pills.length ? (pills[0].className.match(/obg-p-[a-z]+/) || [""])[0] : "";
       if (th.className = "obg-r4-thumb obn-ico" + (pc2 ? " " + pc2 : ""), th.innerHTML = iconFor(label || r && r.cat || ""), pills.length) try {
        var c2 = getComputedStyle(pills[0]).color;
        th.style.color = c2, th.style.background = "color-mix(in srgb, " + c2 + " 13%, #fff)"
       } catch (_) {}
      }
     };
     im.addEventListener("error", function() {
      setTimeout(function() {
       im.complete && im.naturalWidth === 0 && toTile()
      }, 400)
     }), im.complete && im.naturalWidth === 0 && im.getAttribute("src") && setTimeout(function() {
      im.naturalWidth === 0 && toTile()
     }, 400)
    }
    var pr = String(it && it.priority || r && r.priority || "").trim().toLowerCase();
    w.setAttribute("data-obn-pick", a.querySelector(".obg-r4-star") || r && truthy(r.starred) ? "1" : "0"), w.setAttribute("data-obn-hi", pr === "high" || pr === "top" ? "1" : "0"), w.setAttribute("data-obn-min", String(timeMin((a.querySelector(".obg-r4-time") || {}).textContent))), w.setAttribute("data-obn-reg", a.classList.contains("is-reg") ? "1" : "0")
   }
  }
 }

 function sortList(list) {
  var rows = Array.prototype.filter.call(list.children, function(c) {
   return c.classList && c.classList.contains("obg-r4w")
  });
  if (!(rows.length < 2)) {
   rows.forEach(function(w, i) {
    w.hasAttribute("data-obn-i") || w.setAttribute("data-obn-i", String(i))
   });
   var n = function(w, k) {
     return +(w.getAttribute(k) || 0)
    },
    cmp;
   pref.sort === "rec" ? cmp = function(x, y) {
    return n(y, "data-obn-pick") - n(x, "data-obn-pick") || n(y, "data-obn-hi") - n(x, "data-obn-hi") || n(x, "data-obn-reg") - n(y, "data-obn-reg") || n(x, "data-obn-min") - n(y, "data-obn-min") || n(x, "data-obn-i") - n(y, "data-obn-i")
   } : cmp = function(x, y) {
    return n(x, "data-obn-min") - n(y, "data-obn-min") || n(x, "data-obn-i") - n(y, "data-obn-i")
   };
   var want = rows.slice().sort(cmp);
   if (!want.every(function(w, i) {
     return w === rows[i]
    })) {
    var anchor = rows[rows.length - 1].nextSibling;
    want.forEach(function(w) {
     list.insertBefore(w, anchor)
    })
   }
  }
 }
 var COMPACT_IC = sv('<path d="M4 6h16M4 10h16M4 14h16M4 18h16"/>'),
  COMFY_IC = sv('<rect x="4" y="4.5" width="16" height="6" rx="1.5"/><rect x="4" y="13.5" width="16" height="6" rx="1.5"/>'),
  SORT_IC = sv('<path d="M7 4v16M3.5 16.5 7 20l3.5-3.5M14 6h7M14 12h5M14 18h3"/>'),
  PIN_IC = sv('<path d="M12 21s-7-6.2-7-11.5A7 7 0 0 1 19 9.5C19 14.8 12 21 12 21z"/><circle cx="12" cy="9.5" r="2.5"/>'),
  FILT_IC = sv('<path d="M4 7h10M18 7h2M4 17h4M12 17h8"/><circle cx="16" cy="7" r="2"/><circle cx="10" cy="17" r="2"/>');

 function activeCount(st) {
  return st ? (st.cats || []).length + (st.picks ? 1 : 0) + (st.free ? 1 : 0) + (st.dog ? 1 : 0) + (st.drive ? 1 : 0) + (st.kids ? 1 : 0) + (st.open ? 1 : 0) + (st.q ? 1 : 0) + (st.hoods || []).length + (st.weekly ? 1 : 0) : 0
 }

 function dateCards() {
  return Array.prototype.slice.call(document.querySelectorAll("#obg .obg-datebar .obg-dcard"))
 }

 function cardKey(c) {
  return c.getAttribute("data-date") || (c.hasAttribute("data-obwkcard") ? "week" : c.classList.contains("obg-dpick") ? "pick" : "")
 }

 function cardLabel(c) {
  var b = c.querySelector("b"),
   sp = c.querySelector("span"),
   t = (b ? b.textContent : "").trim(),
   d = (sp ? sp.textContent : "").trim();
  return c.classList.contains("obg-dpick") ? "Pick a date\u2026" : t + (d && !/all dates/i.test(d) ? " \xB7 " + d : "")
 }
 var MON3 = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

 function md(k) {
  var a = String(k || "").split("-");
  return a.length === 3 ? MON3[+a[1] - 1] + " " + +a[2] : k
 }

 function dateNow(st) {
  var on = dateCards().filter(function(c) {
   return c.getAttribute("aria-pressed") === "true" && !c.classList.contains("obg-dpick")
  })[0];
  if (on) return {
   key: cardKey(on),
   label: cardLabel(on).replace(" \xB7 ", ", ")
  };
  if (!st || st.when === "all" || !st.when) return {
   key: "all",
   label: "Any date"
  };
  if (st.when === "custom" && st.from) return {
   key: "cur",
   label: md(st.from) + (st.to && st.to !== st.from ? " \u2013 " + md(st.to) : "")
  };
  var names = {
   today: "Today",
   week: "This week",
   weekend: "This weekend",
   month: "This month",
   tomorrow: "Tomorrow"
  };
  return {
   key: "cur",
   label: names[st.when] || "Dates"
  }
 }

 function tools() {
  var root = document.getElementById("obg"),
   fb = document.getElementById("obgFilterbar"),
   list = document.getElementById("obgList");
  if (!(!root || !fb || !list)) {
   var st = state(),
    bar = root.querySelector(".obn-ml-bar");
   bar || (bar = document.createElement("div"), bar.className = "obn-ml-bar", bar.setAttribute("role", "group"), bar.setAttribute("aria-label", "Find events"), bar.innerHTML = '<label class="obn-ml-date">' + sv(CAL) + '<b></b><select data-obn-date aria-label="Date"></select></label><label class="obn-ml-area">' + PIN_IC + '<b></b><select data-obn-area aria-label="Area"></select></label><button type="button" class="obn-ml-filters" data-obn-filters>' + FILT_IC + "Filters<i hidden></i></button>"), !bar.closest(".obg-main") && bar.nextElementSibling !== fb && fb.parentNode.insertBefore(bar, fb);
   var dsel = bar.querySelector("[data-obn-date]"),
    dn = dateNow(st),
    cards = dateCards(),
    opts = [
     ["all", "Any date"]
    ].concat(cards.map(function(c2) {
     return [cardKey(c2), cardLabel(c2)]
    }).filter(function(o2) {
     return o2[0]
    }));
   dn.key === "cur" && opts.unshift(["cur", dn.label]);
   var dsig = opts.map(function(o2) {
    return o2.join("=")
   }).join("|");
   dsel.getAttribute("data-sig") !== dsig && (dsel.innerHTML = opts.map(function(o2) {
    return '<option value="' + esc(o2[0]) + '">' + esc(o2[1]) + "</option>"
   }).join(""), dsel.setAttribute("data-sig", dsig)), dsel.value !== dn.key && (dsel.value = dn.key);
   var dl = bar.querySelector(".obn-ml-date");
   dl.querySelector("b").textContent = dn.label, dl.classList.toggle("is-set", dn.key !== "all");
   var hero = document.getElementById("obgHeroRegion"),
    sel = bar.querySelector("[data-obn-area]"),
    lab = bar.querySelector(".obn-ml-area");
   if (hero) {
    lab.hidden = !1;
    var sig = hero.innerHTML.length + "|" + hero.options.length;
    sel.getAttribute("data-sig") !== sig && (sel.innerHTML = hero.innerHTML, sel.setAttribute("data-sig", sig)), sel.value !== hero.value && (sel.value = hero.value);
    var o = hero.options[hero.selectedIndex];
    lab.querySelector("b").textContent = o ? o.textContent.replace(/^All of /, "").trim() : "", lab.title = o ? o.textContent.trim() : ""
   } else lab.hidden = !0;
   var c = activeCount(st),
    fbn = bar.querySelector("[data-obn-filters]"),
    i = fbn.querySelector("i");
   i.hidden = !c, i.textContent = c ? String(c) : "", fbn.classList.toggle("is-set", !!c), fbn.setAttribute("aria-label", c ? "Filters, " + c + " on" : "Filters");
   var row = document.querySelector("#obg .obn-ml-sortrow");
   row || (row = document.createElement("div"), row.className = "obn-ml-sortrow", row.innerHTML = '<label class="obn-ml-sort">' + SORT_IC + '<b></b><select data-obn-sort aria-label="Sort events"><option value="rec">Recommended</option><option value="time">By time</option></select></label><button type="button" data-obn-dens></button>'), !row.closest(".obg-chipbar") && row.nextElementSibling !== list && list.parentNode.insertBefore(row, list), row.hidden = !!(st && st.view && st.view !== "list");
   var ss = row.querySelector("[data-obn-sort]");
   ss.value !== pref.sort && (ss.value = pref.sort), row.querySelector(".obn-ml-sort b").textContent = pref.sort === "rec" ? "Recommended" : "By time";
   var db = row.querySelector("[data-obn-dens]"),
    comfy = pref.dens === "comfy";
   db.innerHTML = comfy ? COMFY_IC : COMPACT_IC, db.setAttribute("aria-label", comfy ? "Comfortable view (switch to compact)" : "Compact view (switch to comfortable)"), db.setAttribute("aria-pressed", comfy ? "true" : "false"), db.title = comfy ? "Comfortable view" : "Compact view";
   var old = root.querySelector(".obn-ml-fab");
   old && old.parentNode.removeChild(old);
   var oldt = root.querySelector(".obn-ml-tools");
   oldt && oldt.parentNode.removeChild(oldt)
  }
 }

 function setWhenAll() {
  var r = document.querySelector('#obg input[name="obg-when"][value="all"]');
  r && (r.checked = !0, r.dispatchEvent(new Event("change", {
   bubbles: !0
  })))
 }
 document.addEventListener("change", function(e) {
  var t = e.target;
  if (!(!t || !t.closest || !t.closest("#obg .obn-ml-bar, #obg .obn-ml-sortrow"))) {
   if (t.hasAttribute("data-obn-sort")) pref.sort = t.value === "rec" ? "rec" : "time", put("obnSort", pref.sort), track("sort", pref.sort), run();
   else if (t.hasAttribute("data-obn-area")) {
    var hero = document.getElementById("obgHeroRegion");
    hero && hero.value !== t.value && (hero.value = t.value, hero.dispatchEvent(new Event("change", {
     bubbles: !0
    })), track("area_mobile", t.value))
   } else if (t.hasAttribute("data-obn-date")) {
    var v = t.value;
    if (track("date_mobile", v), v === "all") setWhenAll();
    else if (v === "pick") {
     var inp = document.getElementById("obgDatePick");
     if (inp) try {
      inp.showPicker()
     } catch (_) {
      inp.focus(), inp.click()
     }
    } else if (v !== "cur") {
     var c = dateCards().filter(function(x) {
      return cardKey(x) === v
     })[0];
     c && c.getAttribute("aria-pressed") !== "true" && c.click()
    }
    soon()
   }
  }
 }), document.addEventListener("click", function(e) {
  if (e.target.closest) {
   if (e.target.closest("#obg [data-obn-dens]")) {
    pref.dens = pref.dens === "comfy" ? "compact" : "comfy", put("obnDensity", pref.dens), track("density", pref.dens), run();
    return
   }
   if (e.target.closest("#obg .obn-ml-bar [data-obn-filters]")) {
    var m = document.querySelector("#obg .obg-chip-more");
    m && m.click(), track("bar_filters", "open")
   }
  }
 });

 function fabVis() {
  var bar = document.querySelector("#obg .obn-ml-bar"),
   root = document.getElementById("obg");
  if (!(!bar || !root)) {
   var r = bar.getBoundingClientRect(),
    stuck = mobile() && r.top <= lastStick + 1 && r.height > 0;
   bar.classList.toggle("is-stuck", stuck);
   var h = mobile() ? Math.round(r.height) : 0;
   root.__obnBar !== h && (root.__obnBar = h, root.style.setProperty("--obn-bar", h + "px"))
  }
 }
 var hdrs = null;

 function stickTop() {
  hdrs || (hdrs = [], Array.prototype.forEach.call(document.querySelectorAll("body *"), function(el) {
   if (!(hdrs.length > 6 || el.closest("#obg"))) {
    var cs = getComputedStyle(el);
    if ((cs.position === "sticky" || cs.position === "fixed") && parseFloat(cs.top || "1") <= .5) {
     var r = el.getBoundingClientRect();
     r.height > 20 && r.height < 200 && r.width > window.innerWidth * .8 && hdrs.push(el)
    }
   }
  }));
  var b = 0;
  return hdrs.forEach(function(el) {
   var r = el.getBoundingClientRect();
   r.top <= 1 && r.bottom > b && r.bottom < 220 && (b = r.bottom)
  }), Math.max(0, Math.round(b))
 }
 var lastStick = -1;

 function setStick() {
  var root = document.getElementById("obg");
  if (root) {
   var t = mobile() ? stickTop() : 0;
   t !== lastStick && (lastStick = t, root.style.setProperty("--obn-stick", t + "px"))
  }
 }
 var DEST = /^\/pages\/events-(charlotte|denver|honolulu|las-vegas|minneapolis-st-paul|phoenix|portland|salt-lake-city|tempe|tokyo|washington-dc)(-|$)/,
  SOCAL = /^\/pages\/events(-|$)/.test(location.pathname) && !DEST.test(location.pathname),
  WDS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  MOS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  fP = null;

 function parts(ms) {
  fP = fP || new Intl.DateTimeFormat("en-US", {
   timeZone: "America/Los_Angeles",
   weekday: "short",
   month: "short",
   day: "numeric",
   hour: "numeric",
   minute: "2-digit",
   year: "numeric"
  });
  var o = {};
  return fP.formatToParts(new Date(ms)).forEach(function(p) {
   o[p.type] = p.value
  }), o
 }

 function tLbl(ms) {
  var p = parts(ms);
  return p.hour + (p.minute !== "00" ? ":" + p.minute : "") + (p.dayPeriod || "").toLowerCase()
 }
 var fLA = null;

 function laMs(d, t) {
  var a = String(d || "").split("-").map(Number);
  if (a.length < 3 || !a[0]) return NaN;
  var h = 0,
   mi = 0,
   m = String(t || "").match(/(\d{1,2}):(\d{2})/);
  m && (h = +m[1], mi = +m[2]);
  var guess = Date.UTC(a[0], a[1] - 1, a[2], h, mi);
  fLA = fLA || new Intl.DateTimeFormat("en-US", {
   timeZone: "America/Los_Angeles",
   hourCycle: "h23",
   year: "numeric",
   month: "numeric",
   day: "numeric",
   hour: "numeric",
   minute: "numeric"
  });
  var o = {};
  fLA.formatToParts(new Date(guess)).forEach(function(x) {
   o[x.type] = x.value
  });
  var asLA = Date.UTC(+o.year, +o.month - 1, +o.day, +o.hour % 24, +o.minute);
  return guess + (guess - asLA)
 }

 function rawBooths() {
  var raw = window.OB_GUIDE_BOOTHS;
  return Array.isArray(raw) ? raw.map(function(x) {
   var allDay = !x.start_time,
    s = laMs(x.start_date, x.start_time || "00:00"),
    e;
   return x.end_time ? e = laMs(x.end_date || x.start_date, x.end_time) : x.end_date || allDay ? e = laMs(x.end_date || x.start_date, "23:59") : e = s + 6 * 36e5, {
    title: x.title,
    start: isNaN(s) ? "" : new Date(s).toISOString(),
    end: isNaN(e) ? "" : new Date(e).toISOString(),
    all_day: allDay,
    place: x.place,
    hood: x.hood,
    url: x.url,
    image: x.image,
    here: !0
   }
  }) : null
 }

 function booths() {
  for (var list = rawBooths() || window.OB_GUIDE_ITEMS || [], now = Date.now(), seen = {}, out = [], i = 0; i < list.length; i++) {
   var o = list[i],
    r = o && o.__obRaw ? o.__obRaw : o;
   if (!(!r || !r.title || !r.start) && (truthy(r.here) || /ob tie dye|obtiedye|tie[- ]?dye booth/i.test(r.title))) {
    var st = Date.parse(r.start);
    if (!isNaN(st)) {
     var en = r.end ? Date.parse(r.end) : st + 6 * 36e5;
     if (isNaN(en) && (en = st + 6 * 36e5), !(en < now)) {
      var k = String(r.title).toLowerCase().replace(/[^a-z0-9]+/g, " ").trim() + "|" + String(r.start).slice(0, 10);
      seen[k] || (seen[k] = 1, out.push({
       r: r,
       s: st,
       e: en
      }))
     }
    }
   }
  }
  return out.sort(function(a, b) {
   return a.s - b.s
  })
 }

 function mkTracked(u) {
  try {
   var x = new URL(u, location.href);
   return /obtiedye\.com$/.test(x.hostname) || x.hostname === location.hostname ? u : (x.searchParams.has("utm_source") || (x.searchParams.set("utm_source", "obtiedye.com"), x.searchParams.set("utm_medium", "referral"), x.searchParams.set("utm_campaign", "socal_event_guide"), x.searchParams.set("utm_content", "ob_markets")), x.toString())
  } catch (_) {
   return u
  }
 }
 var BOOT_TXT = null,
  BOOT_ASKED = !1;

 function bootImg(r) {
  if (BOOT_TXT == null) {
   if (!BOOT_ASKED) {
    BOOT_ASKED = !0;
    var sc = Array.prototype.filter.call(document.scripts, function(x) {
     return /ob-sd-guide-boot\.js/.test(x.src)
    })[0];
    sc && window.fetch ? fetch(sc.src).then(function(x) {
     return x.text()
    }).then(function(t) {
     BOOT_TXT = t, soon()
    }, function() {
     BOOT_TXT = ""
    }) : BOOT_TXT = ""
   }
   return ""
  }
  if (!BOOT_TXT || !r.title) return "";
  var k = JSON.stringify(String(r.title) + (r.place ? "|" + String(r.place) : "")),
   i = BOOT_TXT.indexOf(k + ':"');
  if (i < 0) return "";
  var v = BOOT_TXT.slice(i + k.length + 2, BOOT_TXT.indexOf('"', i + k.length + 2));
  return /^https?:/.test(v) ? v : "https://cdn.shopify.com/s/files/1/0928/5068/4179/files/ob-tie-dye-san-diego-events-" + v
 }

 function mkRow(b) {
  var r = b.r,
   p = parts(b.s),
   date = p.weekday + " \xB7 " + p.month + " " + p.day,
   pe = parts(b.e - 1e3);
  pe.month + pe.day !== p.month + p.day && (date += " \u2013 " + (pe.month !== p.month ? pe.month + " " : "") + pe.day);
  var time = r.all_day ? "" : tLbl(b.s) + (r.end ? "\u2013" + tLbl(b.e) : ""),
   meta = [time, r.place || r.hood].filter(Boolean).join(" \xB7 "),
   src = r.image && /^https?:/.test(String(r.image)) ? String(r.image) : bootImg(r),
   img = src ? '<span class="obg-thumb"><img src="' + esc(src) + '" alt="" loading="lazy" decoding="async" width="112" height="112"></span>' : '<span class="obg-thumb obn-mk-ico">' + iconFor("Market") + "</span>",
   inner = img + '<span class="obg-mkt-info"><span class="obg-mkt-date">' + esc(date) + '</span><span class="obg-mkt-title">' + esc(r.title) + '</span><span class="obg-mkt-meta">' + esc(meta) + "</span></span>";
  return r.url ? '<a class="obg-mkt" data-obn-mk href="' + esc(mkTracked(r.url)) + '" target="_blank" rel="noopener">' + inner + "</a>" : '<div class="obg-mkt" data-obn-mk>' + inner + "</div>"
 }
 var MK_CSS = "#obg .obn-mk-ico{display:flex;align-items:center;justify-content:center;color:var(--or,#b4541f);background:var(--or-bg,#fbeee5)}#obg .obn-mk-ico .obg-i{width:30px;height:30px}@media all{#obg #obgMarketsRow.obn-mk-all{display:flex!important;flex-direction:column;gap:8px;overflow:visible!important}#obg #obgMarketsRow.obn-mk-all .obg-mkt{width:100%!important;max-width:none!important;flex:0 0 auto}}";

 function markets() {
  if (SOCAL) {
   var sec = document.getElementById("obgMarkets"),
    row = document.getElementById("obgMarketsRow");
   if (!(!sec || !row)) {
    if (!document.getElementById("obn-mkall-css")) {
     var s = document.createElement("style");
     s.id = "obn-mkall-css", s.textContent = MK_CSS, document.head.appendChild(s)
    }
    var list = booths();
    if (list.length) {
     var html = list.map(mkRow).join(""),
      sig = String(html.length) + "|" + list.length + "|" + list[0].s + "|" + (BOOT_TXT == null ? 0 : 1);
     (row.getAttribute("data-obn-sig") !== sig || !row.querySelector("[data-obn-mk]")) && (row.innerHTML = html, row.setAttribute("data-obn-sig", sig)), row.classList.add("obn-mk-all"), sec.hidden && (sec.hidden = !1)
    }
   }
  }
 }

 function run() {
  var root = document.getElementById("obg");
  if (root) {
   if (!document.getElementById("obn-ml-css")) {
    var s = document.createElement("style");
    s.id = "obn-ml-css", s.textContent = CSS, document.head.appendChild(s)
   }
   root.classList.toggle("obn-comfy", mobile() && pref.dens === "comfy");
   var list = document.getElementById("obgList");
   list && (Array.prototype.forEach.call(list.querySelectorAll(".obg-r4w"), enhance), Array.prototype.forEach.call(list.querySelectorAll(".obg-dlist"), sortList)), tools(), fabVis(), setStick(), markets()
  }
 }
 var tmr;

 function soon() {
  clearTimeout(tmr), tmr = setTimeout(run, 30)
 }

 function start() {
  var root = document.getElementById("obg");
  if (root) {
   window.MutationObserver && new MutationObserver(function(ms) {
    for (var i = 0; i < ms.length; i++) {
     var t = ms[i].target;
     if (!(t.closest && (t.closest(".obn-ml-bar") || t.closest(".obn-ml-sortrow")))) {
      soon();
      return
     }
    }
   }).observe(root, {
    childList: !0,
    subtree: !0
   });
   var raf = 0;
   window.addEventListener("scroll", function() {
    raf || (raf = requestAnimationFrame(function() {
     raf = 0, fabVis(), setStick()
    }))
   }, {
    passive: !0
   }), window.addEventListener("resize", function() {
    hdrs = null, soon()
   }), MQ.addEventListener ? MQ.addEventListener("change", soon) : MQ.addListener(soon), soon()
  }
 }
 document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", start) : start(), window.addEventListener("load", function() {
  hdrs = null, soon()
 })
})();
//# sourceMappingURL=/cdn/shop/t/219/assets/ob-guide-mlist.js.map